// =============================================================================
// features/admin/feature-flags/RemovableChip.tsx — Chip Badge + botão remover
// compartilhado pelos 4 eixos de audience (F32-S04).
//
// Extraído de RoleAxisSelect/UserAxisSelect/OrganizationAxisInput — mesmo
// vocabulário visual, só o conteúdo do label muda por eixo.
// =============================================================================

import * as React from 'react';

import { Badge, type BadgeVariant } from '../../../components/ui/Badge';
import { cn } from '../../../lib/cn';

interface RemovableChipProps {
  children: React.ReactNode;
  onRemove: () => void;
  ariaLabel: string;
  variant?: BadgeVariant;
}

export function RemovableChip({
  children,
  onRemove,
  ariaLabel,
  variant = 'neutral',
}: RemovableChipProps): React.JSX.Element {
  return (
    <span className="inline-flex items-center gap-1">
      <Badge variant={variant}>{children}</Badge>
      <button
        type="button"
        onClick={onRemove}
        aria-label={ariaLabel}
        className={cn(
          'w-4 h-4 flex items-center justify-center rounded-pill',
          'text-ink-3 hover:text-danger hover:bg-danger/10',
          'transition-colors duration-fast',
          'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-azul/30',
        )}
      >
        <svg
          viewBox="0 0 12 12"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          className="w-2.5 h-2.5"
          aria-hidden="true"
        >
          <path d="M3 3l6 6M9 3l-6 6" />
        </svg>
      </button>
    </span>
  );
}
